// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.floorplans.RentalManagerUserPropertyFloorPlanEditV2WebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_active,
  RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_dateAvailable,
  RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_highPrice,
  RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_lowPrice,
  RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_name,
  RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_numBathrooms,
  RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_numBedrooms,
  RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_price,
  RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_squareFeet,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  UserPropertyFloorPlanEditActiveResponseV2WebDto,
  UserPropertyFloorPlanEditActiveV2RequestDto,
  UserPropertyFloorPlanEditDateAvailableResponseV2WebDto,
  UserPropertyFloorPlanEditDateAvailableV2RequestDto,
  UserPropertyFloorPlanEditHighPriceResponseV2WebDto,
  UserPropertyFloorPlanEditHighPriceV2RequestDto,
  UserPropertyFloorPlanEditLowPriceResponseV2WebDto,
  UserPropertyFloorPlanEditLowPriceV2RequestDto,
  UserPropertyFloorPlanEditNameResponseV2WebDto,
  UserPropertyFloorPlanEditNameV2RequestDto,
  UserPropertyFloorPlanEditNumBathroomsResponseV2WebDto,
  UserPropertyFloorPlanEditNumBathroomsV2RequestDto,
  UserPropertyFloorPlanEditNumBedroomsResponseV2WebDto,
  UserPropertyFloorPlanEditNumBedroomsV2RequestDto,
  UserPropertyFloorPlanEditPriceResponseV2WebDto,
  UserPropertyFloorPlanEditPriceV2RequestDto,
  UserPropertyFloorPlanEditSquareFeetResponseV2WebDto,
  UserPropertyFloorPlanEditSquareFeetV2RequestDto,
} from '@zg-rentals/ts-rental-manager-api-client';

export interface RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_active_Args {
  postData: UserPropertyFloorPlanEditActiveV2RequestDto;
}

export type RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_active_Options = UseMutationOptions<
  UserPropertyFloorPlanEditActiveResponseV2WebDto,
  unknown,
  RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_active_Args
>;

/**
 * Update activeness of a floor plan
 */
export const useRentalManagerUserPropertyFloorPlanEditV2WebApiHandler_active = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_active_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_active_Args) =>
      RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_active(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_dateAvailable_Args {
  postData: UserPropertyFloorPlanEditDateAvailableV2RequestDto;
}

export type RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_dateAvailable_Options = UseMutationOptions<
  UserPropertyFloorPlanEditDateAvailableResponseV2WebDto,
  unknown,
  RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_dateAvailable_Args
>;

/**
 * Update date available of a floor plan, yyyy-MM-dd
 */
export const useRentalManagerUserPropertyFloorPlanEditV2WebApiHandler_dateAvailable = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_dateAvailable_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_dateAvailable_Args) =>
      RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_dateAvailable(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_highPrice_Args {
  postData: UserPropertyFloorPlanEditHighPriceV2RequestDto;
}

export type RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_highPrice_Options = UseMutationOptions<
  UserPropertyFloorPlanEditHighPriceResponseV2WebDto,
  unknown,
  RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_highPrice_Args
>;

/**
 * Update the highest price of a floor plan
 */
export const useRentalManagerUserPropertyFloorPlanEditV2WebApiHandler_highPrice = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_highPrice_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_highPrice_Args) =>
      RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_highPrice(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_lowPrice_Args {
  postData: UserPropertyFloorPlanEditLowPriceV2RequestDto;
}

export type RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_lowPrice_Options = UseMutationOptions<
  UserPropertyFloorPlanEditLowPriceResponseV2WebDto,
  unknown,
  RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_lowPrice_Args
>;

/**
 * Update the lowest price of a floor plan
 */
export const useRentalManagerUserPropertyFloorPlanEditV2WebApiHandler_lowPrice = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_lowPrice_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_lowPrice_Args) =>
      RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_lowPrice(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_name_Args {
  postData: UserPropertyFloorPlanEditNameV2RequestDto;
}

export type RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_name_Options = UseMutationOptions<
  UserPropertyFloorPlanEditNameResponseV2WebDto,
  unknown,
  RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_name_Args
>;

/**
 * Update name of a floor plan
 */
export const useRentalManagerUserPropertyFloorPlanEditV2WebApiHandler_name = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_name_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_name_Args) =>
      RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_name(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_numBathrooms_Args {
  postData: UserPropertyFloorPlanEditNumBathroomsV2RequestDto;
}

export type RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_numBathrooms_Options = UseMutationOptions<
  UserPropertyFloorPlanEditNumBathroomsResponseV2WebDto,
  unknown,
  RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_numBathrooms_Args
>;

/**
 * Update number of bathrooms of a floor plan
 */
export const useRentalManagerUserPropertyFloorPlanEditV2WebApiHandler_numBathrooms = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_numBathrooms_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_numBathrooms_Args) =>
      RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_numBathrooms(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_numBedrooms_Args {
  postData: UserPropertyFloorPlanEditNumBedroomsV2RequestDto;
}

export type RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_numBedrooms_Options = UseMutationOptions<
  UserPropertyFloorPlanEditNumBedroomsResponseV2WebDto,
  unknown,
  RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_numBedrooms_Args
>;

/**
 * Update number of bedrooms of a floor plan
 */
export const useRentalManagerUserPropertyFloorPlanEditV2WebApiHandler_numBedrooms = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_numBedrooms_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_numBedrooms_Args) =>
      RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_numBedrooms(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_price_Args {
  postData: UserPropertyFloorPlanEditPriceV2RequestDto;
}

export type RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_price_Options = UseMutationOptions<
  UserPropertyFloorPlanEditPriceResponseV2WebDto,
  unknown,
  RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_price_Args
>;

/**
 * Update price of a floor plan
 */
export const useRentalManagerUserPropertyFloorPlanEditV2WebApiHandler_price = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_price_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_price_Args) =>
      RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_price(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_squareFeet_Args {
  postData: UserPropertyFloorPlanEditSquareFeetV2RequestDto;
}

export type RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_squareFeet_Options = UseMutationOptions<
  UserPropertyFloorPlanEditSquareFeetResponseV2WebDto,
  unknown,
  RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_squareFeet_Args
>;

/**
 * Update square feet of a floor plan
 */
export const useRentalManagerUserPropertyFloorPlanEditV2WebApiHandler_squareFeet = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_squareFeet_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_squareFeet_Args) =>
      RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_squareFeet(args.postData, httpClient),
  });
};
